module.exports = __webpack_public_path__ + "static/media/solo-collection.71ad7b97.svg";